module.exports = __webpack_public_path__ + "img/Splash_Screen_God.821aedaf.png";